export default "__VITE_ASSET__DEK6diRQ__"